import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a2611ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tags-wrapper" }
const _hoisted_3 = { class: "title mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebarHeader = _resolveComponent("sidebarHeader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_navigation_drawer, {
      app: "",
      absolute: "",
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
      class: "sidebar sidebar-fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_sidebarHeader, { image: _ctx.image }, null, 8, ["image"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          dense: "",
          nav: "",
          class: "no-padding"
        }, {
          default: _withCtx(() => [
            (_ctx.currentItems?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentItems, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: item.title,
                      link: "",
                      class: "no-padding"
                    }, {
                      default: _withCtx(() => [
                        (index === 0)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: '/',
                              class: "tags-wrapper",
                              "active-class": "router-link-active"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: item.icon
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.icon), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["icon"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_content, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : (_ctx.isArtist && index === 1)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: '/my_info',
                                class: "tags-wrapper",
                                "active-class": "router-link-active"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        icon: item.icon
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_content, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: `/${item.title.toLowerCase()}`,
                                class: "tags-wrapper",
                                "active-class": "router-link-active"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        icon: item.icon
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_content, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_list_item, {
              link: "",
              onClick: _ctx.logout
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_list_item_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-logout")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Logout")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_app_bar, {
      class: "d-flex align-center",
      prominent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          variant: "text",
          onClick: _withModifiers(_ctx.toggleDrawer, ["stop"])
        }, null, 8, ["onClick"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTitle()), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
          : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
      ]),
      _: 3
    })
  ], 64))
}